export default __webpack_public_path__ + "static/media/12.cc00dc8b.jpg";